import img from '../../../img/Group 81.svg'
import img2 from '../../../img/Group 82.svg'


export const heroCard = [
    {
        img: img
    },
    {
        img: img2
    },
    {
        img: img
    },
    {
        img: img2
    }
]